import { useParams } from 'react-router-dom';
import ProfileInnerNavbar, { NavbarItemProps } from '../../../components/ProfileInnerNavbar';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Roles } from '@/components/roles';

type Props = { profile?: boolean, children?: any, prevUrl?: any, userId?: string, role?: any }

const AttendanceNav = (props: Props) => {
  const { t } = useTranslation(['attendance', 'common']);
  const { id } = useParams();

  const navbarItems: NavbarItemProps[] = [
    {
      id: "rules", content: t("attendance:RULES"), to: "/profile/" + id + "/attendance/rules", roles: Roles.HR
    },
  ];

  return (
    <div className="mt-4">
      <ProfileInnerNavbar items={navbarItems} primaryColor={"var(--mowazaf-primary)"} />
      <div className="mt-4 p-4">
        {props.children}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    prevUrl: state.user.prevUrl,
    userId: state.user.userId,
    role: state.user.role
  }
}

export default connect(mapStateToProps, null)(AttendanceNav);